<dx-accordion-group>
    <dx-accordion *ngFor="let group of groups" label="{{group.label}}">
        <app-fipy-module-cards [cards]="cards | cardsByCategory: group.moduleCategory"></app-fipy-module-cards>
    </dx-accordion>
</dx-accordion-group>
